/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

export default function themeTypography(theme) {
  return {
    fontSize: 12,
    htmlFontSize: 14,
    fontFamily: 'Formica_Font_Type',
    h6: {
      fontWeight: 700,
      color: theme.darkBlack,
      fontSize: '0.75rem',
    },
    h5: {
      fontSize: '0.86rem',
      color: theme.darkBlack,
      fontWeight: 400,
    },
    h4: {
      fontSize: '1rem',
      color: theme.darkBlack,
      fontWeight: 400,
    },
    h3: {
      fontSize: '1.2rem',
      color: theme.darkBlack,
      fontWeight: 700,
    },
    h2: {
      fontSize: '1.5rem',
      color: theme.darkBlack,
      fontWeight: 700,
    },
    h1: {
      fontSize: '2.125rem',
      color: theme.darkBlack,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: '1.5rem',
      color: 'black',
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: '0.86rem',
      color: theme.lightBlack,
      fontWeight: 400,
    },
    body1: {
      fontSize: '1rem',
      color: theme.darkBlack,
      fontWeight: 400,
    },
    body2: {
      fontSize: '1.2rem',
      color: theme.darkBlack,
      fontWeight: 400,
    },
    body3: {
      fontSize: '1rem',
      color: theme.darkBlack,
      fontWeight: 400,
    },
    body4: {
      fontSize: '1.1rem',
      color: theme.darkBlack,
      fontWeight: 400,
    },
  };
}
